import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { FuncionService } from '../../servicios/funcion.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment.prod';

@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.css']
})
export class NewsletterComponent implements OnInit {

    action:number = 0;
    uuid:string = "";
    newPath:string = "";
    correoElectronico:string = "";

    constructor( 
        private newFuncionService: FuncionService, 
        private newActivatedRoute: ActivatedRoute, 
        private newRouter: Router,
        private newTitle: Title
        ){}

    ngOnInit(){
        this.newTitle.setTitle("Newsletter");
        this.newPath = this.newRouter.url;
        this.newActivatedRoute.data.subscribe( (response:any) =>{
            this.action = response.action;
            this.newFuncionService.usuarioSesion().subscribe( newUsuario => {
                if( newUsuario.session ){
                    if( newUsuario.suscrito && this.action === 1 ){
                        this.fnCargarNewsletter();
                    }else{
                        this.newRouter.navigate([ '' ]);
                    }
                }else{
                    newUsuario.suscrito = Boolean( localStorage.getItem('suscripcion') );
                    if( this.action === 1 ){
                        this.newRouter.navigate([ '' ]);
                    }else if( this.action === 2 ){
                        this.newActivatedRoute.queryParams.subscribe(params => {
                            this.uuid = params.uuid;
                            if( this.uuid ){
                                this.newFuncionService.fnDesuscribir({ uuid:this.uuid }).subscribe( (response:any) =>{});
                            }else{
                                this.newRouter.navigate([ '' ]);
                            }
                        }).unsubscribe();
                    }
                }
            }).unsubscribe();
        }).unsubscribe();
    }

    fnCargarNewsletter(){
        // console.log( "Cargar newsletter" )
    }

    fnVerificarCorreo(){
        if( this.correoElectronico === "" ){
            this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.vacio );
        }else if( !environment.validacion.correo.test( this.correoElectronico ) ){
            this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.formato );
        }else{
            this.newFuncionService.setNewMensaje("Registrando tu correo a nuestro newsletter");
            this.newFuncionService.fnSuscribir({ correo:this.correoElectronico }).subscribe( (response:any) =>{
                this.newFuncionService.setNewMensaje(null);
                if(response.success){
                    this.correoElectronico = "";
                    this.newFuncionService.setNewAlerta( environment.alerta.newsletter.success );
                }else{
                    this.newFuncionService.setNewAlerta( environment.alerta.newsletter.fail );
                }
                this.newRouter.navigate([ '' ]);
            })
        }
    }

}
